<div class="chart">
  <ngx-charts-bar-vertical-stacked
    *ngIf="hasData"
    [view]="view"
    [scheme]="colorScheme"
    [results]="multi"
    [legendTitle]="legendTitle"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [animations]="animations"
    [yAxisTickFormatting]="yAxisTickFormatting"
    [customColors]="customColors"
    [roundDomains]="true"
    (select)="onSelect($event)"
  >
  </ngx-charts-bar-vertical-stacked>

  <div *ngIf="!hasData" class="no-data-message">
    <div class="no-data-content">
      <i class="pi pi-chart-line" style="font-size: 3rem; color: #ccc;"></i>
      <h4 class="mt-3 mb-2">
        <span translate>NO_DATA_AVAILABLE</span>
      </h4>
      <p class="text-muted">
        <span translate>NO_ACTIVITIES_FOUND_FOR_SELECTED_YEAR</span>
      </p>
    </div>
  </div>
</div>
